import { ReportBodySkeleton } from '../app-layout-skeleton'

export function NestedReportPending() {
  return (
    <div className="@container min-h-0 flex-1 overflow-auto">
      <ReportBodySkeleton />
    </div>
  )
}
